import { createApp } from 'vue';
import 'normalize.css';
import '@assets/css/index.css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import App from './App.vue';
import router from '@infra/router';
// import VueGtag from 'vue-gtag';
import { createPinia } from 'pinia';
// import * as Sentry from '@sentry/vue';

const app = createApp(App);
const pinia = createPinia();

// if (import.meta.env.VITE_APP_NODE_ENV === 'production') {
//   Sentry.init({
//     app,
//     dsn: import.meta.env.VITE_APP_SENTRY_DSN,
//     integrations: [
//       Sentry.browserTracingIntegration({ router }),
//       Sentry.replayIntegration(),
//     ],
//     tracesSampleRate: 0.1,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     tracingOptions: {
//       trackComponents: true,
//       hooks: ['activate', 'mount', 'update', 'unmount'],
//     },
//   });
// }
const gtmId = import.meta.env.VITE_GTM_ID;
if (import.meta.env.VITE_APP_NODE_ENV === 'production') {
  // --- GTM <head> 스크립트 주입 ---
  // 타입스크립트와 ESLint에 맞게 GTM 코드를 재구성
  const dataLayer = window.dataLayer || [];
  window.dataLayer = dataLayer;

  dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const firstScript = document.getElementsByTagName('script')[0];
  const gtmScript = document.createElement('script') as HTMLScriptElement; // 타입 단언 사용
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  }

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

// if (import.meta.env.VITE_APP_NODE_ENV === 'production') {
//   app.use(VueGtag, {
//     config: {
//       id: import.meta.env.VITE_APP_GA,
//       params: {
//         anonymize_ip: true,
//       },
//     },
//   },router);
// }

window.addEventListener('vite:preloadError', (event: Event) => {
  event.preventDefault();
  window.location.reload();
});

app.use(router);
app.use(pinia);
app.mount('#app');
